import { render, staticRenderFns } from "./TaxableRebateSetupNew.vue?vue&type=template&id=046b2186"
import script from "./TaxableRebateSetupNew.vue?vue&type=script&lang=js"
export * from "./TaxableRebateSetupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports